import React from 'react'

import Section from './editable/Section'

import Map from '../Map'

import Block from "./Block";


export default class Block34 extends Block {
  constructor(props){
    super(props)

    this.state = {
      data: props.data,
      editable: props.editable
    }

  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _update(data, callback){
    this.setState({ data }, () => {

      if(callback){
        callback()
      }
      this.updateContentBlock()
    })
  }

  render(){
    let {
      data,
      editable
    } = this.state

    return (
      <Section
          data={ data }
          index={ this.props.index }
          className={ "section-34 block-34 unpad " + this.props.className }
          editable={ editable }
          onUpdated={data => this._update(data)}
          onDelete={() => this.props.onDelete()}
          onAddContentBlockPressed={contentBlock => this.props.onAddContentBlockPressed(contentBlock)}
          canMoveUp={ this.props.canMoveUp }
          canMoveDown={ this.props.canMoveDown }
          onVisibilityButtonPressed={(index) => this.props.onVisibilityButtonPressed(index)}
          onMoveUpPressed={ () => this.props.onMoveUpPressed() }
          onMoveDownPressed={ () => this.props.onMoveDownPressed() }
          onVisibilityToggled={() => this.props.onVisibilityToggled()}
      >
          <div className="map-container m-0">
              <Map
                map={ data.map }
                google={ this.props.google }/>
          </div>
      </Section>
    )
  }
}
